import { useEffect } from 'react'
import { serviceDefinitions } from '../data/parityData'

const KEY = 'difan-admin-services-v2'

function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim() }
function currentRoute() { return (window.location.hash.replace(/^#/, '') || '/').split('?')[0] }
function readRows() { try { const value = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(value) && value.length ? value : serviceDefinitions } catch { return serviceDefinitions } }
function writeRows(rows) { try { localStorage.setItem(KEY, JSON.stringify(rows)) } catch {} }
function serializeScopes(scopes) { return (Array.isArray(scopes) ? scopes : []).map((row) => Array.isArray(row) ? row.map((item) => clean(item)).join(' | ') : '').filter(Boolean).join('\n') }
function parseScopes(value) { return String(value || '').split('\n').map((line) => line.split('|').map((item) => clean(item))).filter((row) => row[0] || row[1] || row[2]).map((row) => [row[0] || 'task_alt', row[1] || '', row.slice(2).join(' | ') || '']) }

function editorModal() {
  return [...document.querySelectorAll('[role="dialog"], .admin-modal, .modal')].find((node) => clean(node.textContent).includes('서비스명') && clean(node.textContent).includes('목록·상세 설명')) || null
}

function currentEditorItem(modal) {
  const nameInput = [...modal.querySelectorAll('input')].find((input) => clean(input.closest('label,div')?.textContent).startsWith('서비스명'))
  const name = clean(nameInput?.value)
  return readRows().find((item) => item.name === name) || serviceDefinitions.find((item) => item.name === name) || null
}

function ensureEditorField() {
  const modal = editorModal()
  if (!modal || modal.querySelector('[data-service-scope-field-parity]')) return
  const description = [...modal.querySelectorAll('textarea')].find((node) => clean(node.closest('label,div')?.textContent).includes('서비스 목록·상세 설명'))
  const anchor = description?.closest('.admin-form-field, label') || description?.parentElement
  if (!anchor?.parentElement) return
  const item = currentEditorItem(modal)
  const wrap = document.createElement('label')
  wrap.dataset.serviceScopeFieldParity = 'true'
  wrap.className = 'admin-form-field admin-form-field-wide'
  wrap.innerHTML = '<span>포함 업무</span><small>서비스 상세의 “이런 업무를 함께 진행할 수 있어요”에 표시되는 필드입니다. 한 줄에 아이콘 | 업무명 | 설명 순서로 입력합니다.</small><textarea data-service-scopes rows="5"></textarea>'
  wrap.querySelector('textarea').value = serializeScopes(item?.scopes)
  anchor.insertAdjacentElement('afterend', wrap)

  const form = modal.querySelector('form')
  if (form && form.dataset.serviceScopeFieldParityBound !== 'true') {
    form.dataset.serviceScopeFieldParityBound = 'true'
    form.addEventListener('submit', () => {
      const nameInput = [...form.querySelectorAll('input')].find((input) => clean(input.closest('label,div')?.textContent).startsWith('서비스명'))
      const name = clean(nameInput?.value)
      const scopes = parseScopes(form.querySelector('[data-service-scopes]')?.value)
      window.setTimeout(() => {
        const rows = readRows()
        const index = rows.findIndex((item) => item.name === name)
        if (index >= 0) rows[index] = { ...rows[index], scopes }
        else rows.unshift({ id: `svc-local-${Date.now()}`, name, scopes })
        writeRows(rows)
        window.dispatchEvent(new Event('difan-admin-service-field-parity-change'))
      }, 80)
    }, true)
  }
}

function ensureDetailRead() {
  const route = currentRoute()
  const match = route.match(/^\/settings\/services\/([^/]+)$/)
  if (!match) return
  const root = document.querySelector('.admin-content')
  if (!root || root.querySelector('[data-service-scope-read-parity]')) return
  const item = readRows().find((row) => row.id === match[1]) || serviceDefinitions.find((row) => row.id === match[1])
  if (!item) return
  const cards = [...root.querySelectorAll('.card')]
  const anchor = cards.find((card) => clean(card.querySelector('.card-header h2')?.textContent) === '서비스 정보') || cards[0]
  if (!anchor) return
  const card = document.createElement('section')
  card.className = 'card'
  card.dataset.serviceScopeReadParity = 'true'
  const rows = Array.isArray(item.scopes) ? item.scopes : []
  card.innerHTML = `<header class="card-header"><div><h2>포함 업무</h2><p>사용자 서비스 상세에 노출되는 업무 범위 원장입니다.</p></div></header><div class="card-body"><dl class="definition-list" data-service-scope-list></dl></div>`
  const list = card.querySelector('[data-service-scope-list]')
  if (rows.length) rows.forEach(([icon, title, description]) => {
    const row = document.createElement('div')
    row.innerHTML = '<dt></dt><dd></dd>'
    row.querySelector('dt').textContent = title || '-'
    row.querySelector('dd').textContent = `${icon || 'task_alt'} · ${description || '-'}`
    list.appendChild(row)
  })
  else list.innerHTML = '<div><dt>포함 업무</dt><dd>등록 데이터 연결 필요</dd></div>'
  anchor.insertAdjacentElement('afterend', card)
}

function apply() { ensureEditorField(); ensureDetailRead() }

export default function AdminServiceScopeFieldParityEnhancer() {
  useEffect(() => {
    let queued = false
    const schedule = () => { if (queued) return; queued = true; queueMicrotask(() => { queued = false; apply() }) }
    apply()
    const observer = new MutationObserver(schedule)
    observer.observe(document.body, { childList: true, subtree: true })
    window.addEventListener('hashchange', schedule)
    window.addEventListener('difan-admin-service-field-parity-change', schedule)
    return () => { observer.disconnect(); window.removeEventListener('hashchange', schedule); window.removeEventListener('difan-admin-service-field-parity-change', schedule) }
  }, [])
  return null
}
